export default theme => ({
    appBar: {
        '@media screen and (max-width: 431px)': {
            backgroundColor: '#ffffff',
            paddingLeft: '50px',
            paddingTop: '40px'
        },
        backgroundColor: '#eeeeee',
        paddingLeft: '30px',
        paddingTop: '30px'
    },
    button: {
        '&.MuiButton-root': {
            border: '1px solid #006AC3',
            borderRadius: '4px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            height: '40px'
        }
    },
    buttonContainer: {
        display: 'flex',
        padding: theme.spacing(3, 0, 3, 0)
    },
    buttonRow: {
        '@media screen and (max-width: 431px)': {
            marginTop: 0
        },
        float: 'right',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(5)
    },
    buttonRowMobileScreen: {
        marginTop: theme.spacing(5)
    },
    cancel: {
        '&.MuiButton-root': {
            border: '1px solid rgba(21,21,21,0.12)',
            borderRadius: '2px',
            boxShadow: 'none',
            color: '#003168',
            fontSize: '12px',
            fontWeight: 400,
            height: '32px',
            letterSpacing: '0.07px',
            lineHeight: '12px',
            width: '79px'
        }
    },
    checkboxMain: {
        '& .au-checkbox-outline-checked': { fill: '#003168' },
        '& .MuiSvgIcon-root': { backgroundColor: 'transparent', fill: 'rgba(0, 49, 104, 0.9)', fontSize: '18px' },
        '&.Mui-focusVisible': {
            outline: 'none'
        },
        color: '#A3A3A3',
        fill: '#003168',
    },
    countryCodeContainer: {
        '@media (min-width: 600px) and (max-width: 900px)': {
            width: '55px'
        },
        '@media screen and (max-width: 431px)': {
            width: 'fit-content',
        },
        width: '120px',
    },
    countryCodeErrorCls: {
        marginTop: '19px',
    },
    countryCodeNoErrorCls: {
        marginTop: '0px',
    },
    customInputRoot: {
        '@media screen and (min-width: 600px) and (max-width: 699px)': {
            paddingRight: '10px !important',
        },
        '@media screen and (min-width: 700px) and (max-width: 900px)': {
            paddingRight: '30px !important',
        },
    },
    extContainer: {
        '@media screen and (max-width: 431px)': {
            paddingTop: '25px'
        },
    },
    extField: {
        '@media (min-width: 600px) and (max-width: 900px)': {
            width: '45px'
        },
        '@media screen and (max-width: 431px)': {
            width: '-webkit-fill-available'
        },
    },
    formGrid: {
        marginTop: '1rem'
    },
    gridContainerCenter: {
        '@media screen and (max-width: 431px)': {
            backgroundColor: '#ffffff',
        },
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
    },
    gridContainerPadding: {
        '@media (min-width: 1100px) and (max-width: 1234px)': {
            flexBasis: '80%',
            maxWidth: '80%'
        },
        '@media (min-width: 1235px) and (max-width: 1328px)': {
            flexBasis: '80%',
            maxWidth: '80%'
        },
        '@media (min-width: 1329px) and (max-width: 1559px)': {
            flexBasis: '65%',
            maxWidth: '65%'
        },
        '@media (min-width: 1600px) and (max-width: 1850px)': {
            flexBasis: '60%',
            maxWidth: '60%'
        },
        '@media (min-width: 431px) and (max-width: 1099px)': {
            flexBasis: '100%',
            maxWidth: '100%'
        },
        '@media screen and (max-width: 431px)': {
            padding: theme.spacing(4, 4, 0, 4)
        },
        padding: theme.spacing(4, 4, 4, 4)
    },
    gridContainerPaddingSuccess: {
        '@media screen and (max-width: 431px)': {
            padding: theme.spacing(4, 0, 4, 0)
        },
        padding: theme.spacing(4, 4, 4, 0)
    },
    inputCountryCodeProps: {
        '&.Mui-focused': {
            color: '#003168'
        },
        '@media screen and (max-width: 431px)': {
            '&.Mui-focused': {
                color: '#003168'
            },
            color: 'rgba(0,49,104,0.54)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 400,
            letterSpacing: '0.1px',
            lineHeight: '20px',
        },
        color: 'rgba(0,0,0,0.54)',
        fontFamily: 'Roboto',
        fontSize: '16px',
        fontWeight: 400,
        letterSpacing: '0.1px',
        lineHeight: '20px'
    },
    inputCountryCodeTextProps: {
        '& .Mui-focused': {
            color: '#003168'
        },
        '& .MuiAutocomplete-clearIndicator': { display: 'none' },
        '& .MuiAutocomplete-inputRoot .MuiAutocomplete-hasPopupIcon .MuiAutocomplete-hasClearIcon': {
            '@media (min-width: 600px) and (max-width: 850px)': {
                paddingRight: '0px'
            },
        },
        '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
            '@media (min-width: 600px) and (max-width: 850px)': {
                paddingRight: '0px',
                width: '45px'
            },
            '@media screen and (max-width: 431px)': {
                width: '56vw'
            },
            minWidth: '70px',
            width: '85px'
        },
        '@media screen and (max-width: 431px)': {
            '& .Mui-focused': {
                color: '#003168'
            },
            color: 'rgba(0,49,104,0.54)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 400,
            letterSpacing: '0.1px',
            lineHeight: '20px',
        },
        color: 'rgba(0,0,0,0.54)',
        fontFamily: 'Roboto',
        fontSize: '16px',
        fontWeight: 400,
        letterSpacing: '0.1px',
        lineHeight: '20px',
    },
    inputMataLabelProps: {
        '&.Mui-focused': {
            color: '#003168'
        },
        '@media screen and (max-width: 431px)': {
            '&.Mui-focused': {
                color: '#003168'
            },
            color: 'rgba(0,49,104,0.54)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 400,
            letterSpacing: '0.1px',
            lineHeight: '20px',
        },
        color: 'rgba(0,0,0,0.54)',
        fontFamily: 'Roboto',
        fontSize: '16px',
        fontWeight: 400,
        letterSpacing: '0.1px',
        lineHeight: '20px',
    },
    interestedIn: {
        '@media (min-width: 671px) and (max-width: 810px)': {
            marginLeft: '5px',
        },
        '@media screen and (max-width: 670px)': {
            columnGap: '6px',
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
        display: 'flex',
        marginLeft: '15px'
    },
    interestedInChild: {
        '@media screen and (max-width: 431px)': {
            marginRight: '0',
            width: '116px'
        },
        marginRight: theme.spacing(6),
    },
    interestedInContainer: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: theme.spacing(4),
    },
    interestedInMobile: {
        columnGap: '6px',
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
    },
    interestedInTitle: {
        '@media screen and (max-width: 431px)': {
            minWidth: 'fit-content'
        },
        color: 'rgba(0,0,0,0.54)',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '0.1px',
        lineHeight: '20px'
    },
    labelMain: {
        color: 'rgba(0,0,0,0.54)',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '0.1px',
        lineHeight: '20px'
    },
    MATALogo: {
        width: '150px'
    },
    paddingContainer: {
        paddingTop: '48px',
    },
    paddingContainerPhoneNumber: {
        '@media screen and (max-width: 431px)': {
            flexDirection: 'column',
        },
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
        paddingTop: '48px',
    },
    phoneInput: {
        '.PhoneInputCountryIcon': {
            display: 'none'
        }
    },
    phoneNumberContainer: {
        '@media screen and (max-width: 431px)': {
            marginLeft: '0px',
            paddingTop: '25px',
        },
        display: 'flex',
        flexGrow: '1',
        marginLeft: '15px',
    },
    rcAnchorErrorMsgContainer: {
        display: 'none'
    },
    recaptcha: {
        '@media screen and (max-width: 431px)': {
            padding: 0
        },
    },
    submit: {
        '&.MuiButton-root': {
            backgroundColor: '#003168',
            borderRadius: '2px',
            boxShadow: 'none',
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 400,
            height: '32px',
            letterSpacing: '0.07px',
            lineHeight: '12px',
            width: '76px'
        }
    },
    submitFr: {
        width: '90px'
    },
    submitRequestContainer: {
        '@media screen and (max-width: 320px)': {
            minHeight: '40vh',
            padding: '0px'
        },
        borderRadius: '8px',
        boxShadow: 'none',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '55vh',
        padding: '32px'
    },
    title: {
        color: '#003168',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '32px',
        fontWeight: '400',
        letterSpacing: '0',
        lineHeight: '38px',
        whiteSpace: 'pre-line'
    },
    titleHeader: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    toolbar: {
        alignItems: 'center',
        display: 'flex',
        height: 'inherit',
        justifyContent: 'space-between',
        paddingRight: '64px',
    },
    toolbarMobile: {
        alignItems: 'flex-start',
        paddingRight: '16px'
    },
    verbiage: {
        color: 'rgba(0,0,0,0.54)',
        fontSize: '16px',
        fontWeight: '300',
        letterSpacing: '0',
        lineHeight: '24px',
        paddingTop: '16px',
        whiteSpace: 'pre-line'
    }
})
